/**
 * Utility functions for token generation
 */

/**
 * Generate a cryptographically secure random token
 * @param length - Length of the token (default: 32)
 * @returns Random token string
 */
export const generateSecureToken = (length: number = 32): string => {
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

/**
 * Generate a verification token for webhook
 * Recommended minimum 32 characters for security
 */
export const generateVerificationToken = (): string => {
    return generateSecureToken(32);
};
